<template>
  <div class="flex flex-col gap-2">
    <Label for="setup-resources">{{ t('admin.setup.contact.resources.label') }}</Label>
    <Input
      id="setup-resources"
      v-model="form.EXTERNAL_RESOURCES_URL"
      type="url"
      placeholder="https://"
      aria-describedby="setup-resources-description"
      data-test-id="setup-resources-input"
    />
    <p id="setup-resources-description" class="text-sm text-muted-foreground">
      {{ t('admin.setup.contact.resources.description') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { usePlatformSetup } from '@/features/admin/platform-setup/hooks/use-platform-setup.hook'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()
const { form } = usePlatformSetup()
</script>
